import { Alert, Box, Text } from '@factorialco/deprecated-design-system'
import { FormikErrors } from 'formik'

import i18n from 'modules/core/lib/i18n'

import { FormValues as EditFormValues } from './Item/forms'
import { FormValues as CreateFormValues } from './forms'

interface Props {
  formErrors: FormikErrors<EditFormValues | CreateFormValues>
}

export const MissingFieldsAlert = ({ formErrors }: Props) => {
  const errorsKeys = Object.keys(formErrors)

  const errorMessage = (field: keyof EditFormValues | CreateFormValues) => {
    switch (field) {
      case 'atsApplicationPhaseIds':
        return i18n.t('ats.job_posting_settings.smart_actions.sidepanel.form_validations.phases')
      case 'messageContent':
        return i18n.t(
          'ats.job_posting_settings.smart_actions.sidepanel.form_validations.message_content'
        )
      default:
        return `${i18n.t('common.missing_field')}: ${field}`
    }
  }

  if (errorsKeys.length === 0) return null

  return (
    <Alert color="error">
      <Box component="ul" gap="s16">
        {errorsKeys.map((field) => (
          <Box key={`form-error-${field}`} component="li">
            <Text.Normal color="grey1000">
              {/* eslint-disable-next-line no-type-assertion/no-type-assertion */}
              {errorMessage(field as keyof EditFormValues | CreateFormValues)}
            </Text.Normal>
          </Box>
        ))}
      </Box>
    </Alert>
  )
}
